<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<p class="image"><span epub:type="pagebreak" id="page_4"><span epub:type="pagebreak" id="page_5"><img alt="contents" src="images/cont.jpg" style="width: 50%"/></span></span></p>
<p class="toc"><a href="#/xhtml/intro">introduction</a></p>
<p class="toc-chap"><a href="#/xhtml/ch01">chapter I<br/> <span class="big"><strong>0001–0375 ANIME + MANGA</strong></span></a></p>
<p class="toc-chap"><span href="#/xhtml/ch02" title="Link target outside of Sample">chapter II<br/> <span class="big"><strong>0376–0645 VIDEO GAMES</strong></span></span></p>
<p class="toc-chap"><span href="#/xhtml/ch03" title="Link target outside of Sample">chapter III<br/> <span class="big"><strong>0646–0689 TELEVISION</strong></span></span></p>
<p class="toc-chap"><span href="#/xhtml/ch04" title="Link target outside of Sample">chapter IV<br/> <span class="big"><strong>0690–0781 MOVIES + BOOKS</strong></span></span></p>
<p class="toc-chap"><span href="#/xhtml/ch05" title="Link target outside of Sample">chapter V<br/> <span class="big"><strong>0782–0882 COMIC BOOKS</strong></span></span></p>
<p class="toc-chap"><span href="#/xhtml/ch06" title="Link target outside of Sample">chapter VI<br/> <span class="big"><strong>0883–0981 CUSTOM CHARACTERS</strong></span></span></p>
<p class="toc-chap"><span href="#/xhtml/ch07" title="Link target outside of Sample">chapter VII<br/> <span class="big"><strong>0982–1000 PROPS</strong></span></span></p>
<p class="toca"><span href="#/xhtml/contri" title="Link target outside of Sample">contributor directory</span></p>
<p class="toc"><span href="#/xhtml/about" title="Link target outside of Sample">about the authors</span></p>
<p class="toc"><span href="#/xhtml/ack" title="Link target outside of Sample">acknowledgments</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?6151a936